module.exports = __webpack_public_path__ + "Step4_Header_new.21529e72.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Step4_Header_new.png
// module id = Vj5g
// module chunks = 0